import { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import { calendarOwnerOf } from '../sharing';
import { atMinutes, busyIntervals, type Interval } from './availability';

/** Gli impegni (task commerciali) di una persona in un giorno, letti dal database. */
export function useDayBusy(personId: string | null, day: string, excludeActivityId?: string | null) {
  const [busy, setBusy] = useState<Interval[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const d = /^\d{4}-\d{2}-\d{2}$/.test(day) ? new Date(`${day}T00:00:00`) : null;
    if (!personId || !d || Number.isNaN(d.getTime())) { setBusy([]); return; }
    let cancelled = false;
    setLoading(true);
    const from = atMinutes(d, 0).toISOString();
    const to = atMinutes(d, 24 * 60).toISOString();
    const skip = (excludeActivityId || '').replace(/^sales_activity_/, '');
    supabase
      .from('sales_activities')
      .select('id, due_date, end_date, status, assigned_to, user_id')
      .or(`assigned_to.eq.${personId},and(assigned_to.is.null,user_id.eq.${personId})`)
      .gte('due_date', from)
      .lt('due_date', to)
      .then(({ data, error }) => {
        if (cancelled) return;
        setLoading(false);
        if (error) { setBusy([]); return; }
        const items = (data || [])
          .filter((a: any) => a.id !== skip && a.status !== 'cancelled' && calendarOwnerOf(a) === personId)
          .map((a: any) => ({
            start_time: a.due_date,
            end_time: a.end_date || new Date(new Date(a.due_date).getTime() + 60 * 60000).toISOString(),
            ownerId: personId,
          }));
        setBusy(busyIntervals(items, d, personId));
      });
    return () => { cancelled = true; };
  }, [personId, day, excludeActivityId]);

  return { busy, loading };
}
